import { useState } from 'react';
import { ACCION_HISTORIAL, EntradaHistorial } from '@/lib/contratos';
import { formatDateTime } from '@/lib/utils';

/** Historial de un contrato o una plantilla: quién hizo qué y cuándo, lo último arriba. */
export default function HistorialLista({ entradas, maximo = 8 }: { entradas?: EntradaHistorial[] | null; maximo?: number }) {
  const [todo, setTodo] = useState(false);
  const lista = [...(entradas || [])].reverse();
  if (lista.length === 0) return <p className="text-xs text-sereno-dark/40">Sin historial todavía.</p>;
  const visibles = todo ? lista : lista.slice(0, maximo);
  return (
    <div>
      <ol className="space-y-2">
        {visibles.map((e, i) => (
          <li key={`${e.at}-${i}`} className="text-xs border-l-2 border-gray-200 pl-3">
            <p className="font-medium text-sereno-dark">{ACCION_HISTORIAL[e.accion] || e.accion}</p>
            {e.detalle && <p className="text-sereno-dark/70 break-words">{e.detalle}</p>}
            <p className="text-sereno-dark/40">{formatDateTime(e.at)} · {e.por}</p>
          </li>
        ))}
      </ol>
      {lista.length > maximo && (
        <button onClick={() => setTodo(t => !t)} className="text-xs text-sereno-dark/60 hover:text-sereno-dark mt-2 underline">
          {todo ? 'Ver menos' : `Ver las ${lista.length} entradas`}
        </button>
      )}
    </div>
  );
}
